import sha1 from 'sha1'
/**
 * 在线咨询
 * userInfo: 用户信息
 */
export default function consultJump (userInfo = {}) {
  const {
    name = '',
    defaultCompanyName = '',
    mobile = ''
  } = userInfo
  const cName = name // 用户姓名
  const cPhone = mobile // 手机号
  const timestamp = new Date().getTime() // 时间戳
  const webToken = mobile // 手机号
  const cOrg = defaultCompanyName // 组织名称
  const nonce = timestamp
  let signStr = `nonce=${timestamp}&timestamp=${timestamp}&web_token=${webToken}&543a3547e9ef5ff6f393ce33936196c9`
  signStr = sha1(signStr).toUpperCase() // 签名
  let url = `https://ut.supcon.com/im_client/?web_plugin_id=34&c_name=${cName}&c_phone=${cPhone}&web_token=${webToken}&timestamp=${timestamp}&signature=${signStr}&nonce=${nonce}&c_org=${cOrg}`
  console.log(url)
  window.open(url, '_blank')
}
